import { createGlobalStyle } from 'styled-components';
import { raizEscala } from './escala';

const GlobalStyles = createGlobalStyle`
/*
  0. A escala fluida (--u e as escadas --fs-* / --sp-*). Fica aqui dentro, e não
     num segundo createGlobalStyle, para não existir pergunta de ordem de
     injeção: onde há GlobalStyles, há a unidade. Ver escala.ts.
*/
${raizEscala}
/*
  1. Use a more-intuitive box-sizing model.
*/
*, *::before, *::after {
  box-sizing: border-box;
}
/*
  2. Remove default margin
*/
* {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font: 400 1rem Poppins, sans-serif;
  /*
    O corpo é a base que todo texto sem font-size próprio herda — é a troca de
    maior alcance da escala. Vem DEPOIS do atalho \`font\` porque o atalho
    reescreve font-size (e é ele, não o \`line-height: 1.5\` acima, que decide a
    entrelinha do corpo hoje: o atalho zera line-height para \`normal\`. Esse
    comportamento é o de hoje e está preservado de propósito).
    Não se troca o 1rem dentro do atalho: \`font\` com var() vira valor de
    substituição pendente e, se a variável faltasse, o atalho INTEIRO cairia.
  */
  font-size: var(--fs-base);
}
/*
  5. Improve media defaults
*/
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
input, button, textarea, select {
  font: 400 1rem Poppins, sans-serif;
  /* Campo e botão não herdam fonte do corpo: precisam da escala em separado. */
  font-size: var(--fs-base);
}
/*
  7. Avoid text overflows
*/
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}
/*
  8. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
}
`
export default GlobalStyles;